var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarPassThanksCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.2031,
    height: 31.6367,
    rx: 7.38264,
    fill: "#1C1C1E",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.1992 21.2703C23.1992 22.5946 22.1865 23.6073 20.8622 23.6073H9.95627C8.63197 23.6073 7.61928 22.5946 7.61928 21.2703V15.0383H23.1992V21.2703ZM9.95627 9.58534H11.5143V8.80634C11.5143 8.33894 11.8259 8.02734 12.2933 8.02734C12.7607 8.02734 13.0723 8.33894 13.0723 8.80634V9.58534H17.7462V8.80634C17.7462 8.33894 18.0578 8.02734 18.5252 8.02734C18.9926 8.02734 19.3042 8.33894 19.3042 8.80634V9.58534H20.8622C22.1865 9.58534 23.1992 10.598 23.1992 11.9223V13.4803H7.61928V11.9223C7.61928 10.598 8.63197 9.58534 9.95627 9.58534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPassThanksCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-pass-thanks-calendar-icon.c399a5b4b822811bcae86de4c8a947b4.svg";
export { ForwardRef as ReactComponent };